import Templater from '@hc-frontend/shared-assets/src/js/utils/dom/Templater'
import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'
import getPremium from 'core/controllerPlans/getPremium'
import moneyFormat from 'utils/format/money'
import innerHTML from 'utils/DOM/innerHTML'
import getById from 'utils/DOM/getById'
import store from 'utils/store/withMiddleware'
import { propAccessor } from '@hc-frontend/utils'
import {
  DENTAL,
  VISION_ID,
  AMERITAS_DENTAL,
  AMERITAS_VISION,
  RENAISSANCE_PRODUCTS
} from 'core/constants/products'

function handleOpenModalDental(e) {
  e.preventDefault()
  const state = store.getState()
  const planId = +this.getAttribute('data-id')
  const dentalPlan = state.plans[planId]
  const contextPlanId = +this.getAttribute('data-planId')
  const templateModal = Templater(getById('template-dental-modal').innerText)
  const plansToShow = [dentalPlan]
  let total = getPremium(dentalPlan)

  const vision = RENAISSANCE_PRODUCTS.includes(dentalPlan.productId)
    ? state.plans[VISION_ID]
    : null
  if (vision) {
    total += getPremium(vision)
    plansToShow.push(vision)
  }

  const addonsByContextPlan = propAccessor(state.addonsByPlan, String(contextPlanId), [])
  const dentalAddonByContextPlan = propAccessor(
    state.dentalAddons,
    String(contextPlanId),
    undefined
  )

  const visionSelected =
    dentalPlan.productId === DENTAL &&
    (state.visionPlanId || addonsByContextPlan.includes(VISION_ID))

  const remove =
    state.dentalPlanId === planId ||
    state.planId === planId ||
    planId === dentalAddonByContextPlan

  const hasDental = remove && !visionSelected
  const hasVision = remove && visionSelected
  const hcStorage = state.hcStorage
  const stateAbbrev = hcStorage.location.state_acronym
  const isAmeritas =
    dentalPlan.productId === AMERITAS_DENTAL || dentalPlan.productId === AMERITAS_VISION

  Promise.all(
    plansToShow.map(plan => fetchJSONHandleError({ url: state.jsons[plan.jsonId] }))
  ).then(details => {
    innerHTML(
      '#addOnModal .modal-body',
      templateModal(
        {
          id: planId,
          title: plansToShow.map(item => item.planName).join(' + '),
          plans: plansToShow,
          details,
          remove,
          contextPlanId,
          hasDental,
          hasVision,
          total: moneyFormat(total),
          showWithPrice: true,
          ids: plansToShow.map(plan => plan.planId).join(','),
          brochures: state.brochures,
          isValue: /value/i.test(state.plans[planId].planName),
          stateAbbrev,
          isAmeritas,
          multiCarrier: state.plans[contextPlanId].multiCarrierPlan
        },
        {
          moneyFormat,
          getPremium
        }
      )
    )

    $('#addOnModal').modal('show')
  })
}

export default handleOpenModalDental
